
export interface FormErrorParams {
    max?: number;
    min?: number;
    requiredLength?: number;
    minValue?: number;
    maxValue?: number;
    exactLength?: number;
    example?: string;
}


export interface FormErrorMessage {
    [key: string]: { label: string; params: (error: FormErrorParams) => any[] };
}

export const errorMessages: FormErrorMessage = {
    required: { label: 'Required', params: () => [null, null] },
    phoneFax: { label: 'Must be a valid number', params: () => [null, null] },
    email: { label: 'Must be a valid email address', params: () => [null, null] },
    max: { label: 'Maximum value is $1', params: (error: FormErrorParams) => [error.max, null] },
    min: { label: 'Minimum value is $1', params: (error: FormErrorParams) => [error.min, null] },
    maxlength: { label: 'Must be up to $1 characters long', params: (error: FormErrorParams) => [error.requiredLength, null] },
    minlength: { label: 'Must be at least $1 characters long', params: (error: FormErrorParams) => [error.requiredLength, null] },
    noValues: { label: 'Not available', params: () => [null, null] },
    dateIsAfterToday: { label: 'Must be before the current date\time', params: () => [null, null] },
    dayIsBeforeToday: { label: 'Must be after the current date\time', params: () => [null, null] },
    lettersNumbers: { label: 'Only letters and numbers', params: () => [null, null] },
    letters: { label: 'Only letters', params: () => [null, null] },
    charactersRange: { label: 'Must be a value between $1 and $2', params: (error: FormErrorParams) => [error.minValue, error.maxValue] },
    amountOfCharacters: { label: 'Must be $1 characters', params: (error: FormErrorParams) => [error.exactLength, null] },
    wholeNumbersRange: { label: 'Only whole numbers between $1 and $2', params: (error: FormErrorParams) => [error.minValue, error.maxValue] },
    numbersRange: { label: 'Must be a value between $1 and $2 numbers long', params: (error: FormErrorParams) => [error.minValue, error.maxValue] },
    lettersRange: { label: 'Must be a value between $1 and $2 letters long', params: (error: FormErrorParams) => [error.minValue, error.maxValue] },
    amountOfLettersNumbers: { label: 'Must be $1 characters, letters and numbers', params: (error: FormErrorParams) => [error.exactLength, null] },
    customFormat: { label: 'Must be a value in the format $1', params: (error: FormErrorParams) => [error.example, null] },
    notIntegerNumber: { label: 'Only an integer number', params: () => [null, null] },
    notDecimalNumber: { label: 'Only a decimal number', params: () => [null, null] },
    whitespace: { label: 'Invalid entry', params: () => [null, null] }
};
